/**
 * useSafeTranslation
 *
 * A wrapper around useTranslation that automatically escapes apostrophes
 * to prevent React linter warnings about unescaped entities.
 *
 * Dependencies:
 * - react-i18next
 * - escapeApostrophes utility
 */
import { useTranslation, UseTranslationOptions, UseTranslationResponse } from 'react-i18next'
import { escapeApostrophes } from '../lib/utils'

export function useSafeTranslation(
  ns?: string | string[],
  options?: UseTranslationOptions<'translation'>
): Omit<UseTranslationResponse<string | string[], 'translation'>, 't'> & {
  t: (key: string, options?: Record<string, any>) => string
} {
  const translation = useTranslation(ns, options)

  // Create a wrapped t function that escapes apostrophes
  const safeT = (key: string, options?: Record<string, any>): string => {
    const translated = translation.t(key, options)
    return escapeApostrophes(translated)
  }

  return {
    ...translation,
    t: safeT
  }
}

export default useSafeTranslation
